import React, {useLayoutEffect, useState} from 'react';
import {
  Backdrop,
  Modal,
  Fade,
  Typography,
  Paper,
  Button,
  Box,
  Grid,
} from '@mui/material';
import { Input } from 'components/layout';
import { useTranslation } from 'react-i18next';
import { FormProvider, useForm } from 'react-hook-form';
import { FormChipList, FormMonacoEditor } from 'components/common';
import { useTheme } from '@mui/material/styles';



const InventoryGroupChildrenModal = (props) => {
  const {
    open,
    handleClose,
    onSubmitCreate,
    onSubmitEdit,
    defaultValues = {},
    isEdit,
    policies,
    items,
    currentGroups,
    index
  } = props;
  const [t] = useTranslation();
  const actionType = isEdit ? 'edit' : 'create';
  const methods = useForm({defaultValues});
  const {control, handleSubmit, getValues, setError, setValue} = methods;
  const theme = useTheme();

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    p: 3,
    backgroundColor: 'white',
  };

  const srollBarStyles = {
    overflowY: 'scroll',
    maxHeight: '70vh',
    '&::-webkit-scrollbar': {
      width: '16px'
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '8px',
      backgroundColor: theme.palette.primary[100],
      border: `4px solid ${theme.palette.common.white}`,
      '&:hover': {
        backgroundColor: theme.palette.primary[200]
      },
      '&:active': {
        backgroundColor: theme.palette.primary[300]
      }
    }
  }

  const fields = [
    {policy: policies.modalChildrenGroupName},
    {policy: policies.modalChildrenGroupDescription},
    {policy: policies.modalChildrenGroupHosts, options: currentGroups },
  ];
  const tagsField = {...policies.modalTags, defaultValues: getValues(policies.modalTags.name)};

  function handleOnSubmit(data) {

    const newChildrenGroup = {
      name: data.modalChildrenGroupName,
      description: data.modalChildrenGroupDescription,
      tags: data.modalTags,
      hostGroups: data.modalChildrenGroupHosts,
      groupsToShow: data.modalChildrenGroupHosts.map(g => g.label).join(',')
    }
    if (isEdit) {
      onSubmitEdit({...newChildrenGroup, index});
    } else {
      const childrenFound = items.find(h => h.name.trim() === data.modalChildrenGroupName.trim());
      if (childrenFound) {
        setError(policies.modalChildrenGroupName.name, {message: t('inventoryList.childrenGroupHost.error.childrenGroupHostFound')});
        return;
      }
      onSubmitCreate(newChildrenGroup);
    }

  }

  const handleOnChange = (name) => {
    return (value) => setValue(name, value);
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      sx={{
        backdropFilter: 'blur(2px)',
      }}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Paper sx={style}>
          <FormProvider { ...methods }>
            <form>
              <Grid container spacing={2} sx={srollBarStyles}>

                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Typography id="transition-modal-title" variant="h6" component="h2">
                    { t(`inventoryList.childrenGroupHost.${actionType}.title`) }
                  </Typography>
                </Grid>

                { fields.map((field, index) => (
                  <Grid item key={index} xs={12} sm={12} md={6} lg={6} sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start'
                  }}>
                    <Input
                      {...field.policy}
                      control={control}
                      options={field.options}
                      sx={{ width: '100%' }}
                    />
                  </Grid>
                ))}

                <Grid item xs={12} sm={12} md={12} lg={12} key={policies.modalTags.name}>
                  <FormChipList
                    {...tagsField}
                    control={control}
                    onChange={handleOnChange(tagsField.name)}
                  />
                </Grid>

              </Grid>

              <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                justifyContent: 'flex-end',
                gap: 2,
                mt: 2
              }}>
                <Button onClick={handleClose}>
                  { t(`template.stepper.polling.modal.buttonClose`) }
                </Button>
                <Button variant='contained' onClick={handleSubmit(handleOnSubmit)}>
                  { t(`template.stepper.polling.modal.${actionType}.button`) }
                </Button>
              </Box>
            </form>
          </FormProvider>
        </Paper>
      </Fade>
    </Modal>
  );

}

export default InventoryGroupChildrenModal;